import { Accordion, Box, Text } from '@wix/design-system';
import React from 'react';
import { ChevronDown, ChevronRight } from '@wix/wix-ui-icons-common';
import { useLibraryTranslations } from '../../../context/TranslationsContext';
export const Scopes = _ref => {
  var _items$, _items$2;
  let {
    consentPermissions
  } = _ref;
  const {
    t
  } = useLibraryTranslations();
  const isMultiplePermissions = consentPermissions.length > 1;
  const items = consentPermissions.map(scope => ({
    ...commonAccordionItemProps,
    title: t(`${scope}.title`),
    children: /*#__PURE__*/React.createElement(Text, {
      size: "small",
      secondary: true
    }, t(`${scope}.description`))
  }));
  return /*#__PURE__*/React.createElement(Box, {
    display: "block",
    overflow: "scroll",
    flexGrow: 1
  }, isMultiplePermissions ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    paddingTop: "12px"
  }), /*#__PURE__*/React.createElement(Accordion, {
    dataHook: "consent-multiple-permissions",
    horizontalPadding: "tiny",
    hideShadow: true,
    skin: "light",
    size: "tiny",
    items: items
  })) : /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP1",
    gap: "SP2",
    dataHook: "consent-single-permission"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, (_items$ = items[0]) == null ? void 0 : _items$.title), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, (_items$2 = items[0]) == null ? void 0 : _items$2.children)));
};
const commonAccordionItemProps = {
  expandLabel: /*#__PURE__*/React.createElement(ChevronRight, null),
  collapseLabel: /*#__PURE__*/React.createElement(ChevronDown, null),
  buttonType: 'node',
  showLabel: 'always'
};
//# sourceMappingURL=Scopes.js.map